function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2105 4.82843C11.2105 4.82843 6.77691 0.384345 6.73984 0.341585C6.55945 0.132756 6.29603 0 6 0C5.69161 0 5.4188 0.144689 5.23841 0.368931C5.19986 0.417161 0.789487 4.82843 0.789487 4.82843C0.403504 5.21675 0.403504 5.84672 0.789487 6.23454C1.17547 6.62286 1.80164 6.62286 2.18713 6.23454L5.01157 3.39347V13.0006C5.01157 13.5525 5.45439 14 6 14C6.54611 14 6.98843 13.5525 6.98843 13.0006V3.39347L9.81287 6.23454C10.1984 6.62286 10.8245 6.62286 11.2105 6.23454C11.5965 5.84672 11.5965 5.21675 11.2105 4.82843Z",
  fill: "white"
});

function SvgIconButtonSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonSend);
export default __webpack_public_path__ + "static/media/icon-button-send.2eae717c.svg";
export { ForwardRef as ReactComponent };